import { render, staticRenderFns } from "./SelfAssessmentRecoveryTest.vue?vue&type=template&id=d4e37046&scoped=true&"
import script from "./SelfAssessmentRecoveryTest.vue?vue&type=script&lang=ts&"
export * from "./SelfAssessmentRecoveryTest.vue?vue&type=script&lang=ts&"
import style0 from "./SelfAssessmentRecoveryTest.vue?vue&type=style&index=0&id=d4e37046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e37046",
  null
  
)

export default component.exports